import Container from "@mui/material/Container";
import SportsbookTable from "./SportsbookTable";

export default function SportsbookPage() {

  return (
    <Container sx={{ margin: '5'}}>
      <SportsbookTable />
    </Container>
  );
}